import React, { useEffect, useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import useOutSideSubClick from "../../common/useOutSideSubClick";
import styled from "styled-components";
import SelectModalContainer from "../SelectModalContainer";

function PCSelectModal({ title, onClose, children }) {
  const modalRef = useRef(null)
  const handleClose = () => {
    onClose?.();
  };

  useEffect(() => {
    // Mount 될때만 실행된다.
    const $body = document.querySelector("body");
    const overflow = $body.style.overflow;
    $body.style.overflow = "hidden";
    return () => {
    	$body.style.overflow = overflow
    };
  }, []);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' || event.keyCode === 27) {
        onClose?.();
      }
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [onClose]);

  useOutSideSubClick(modalRef, handleClose);

  return (
    <SelectModalContainer>
      <Overlay>
        <ModalWrap ref={modalRef} className="in_select_modal">
          <div style={ { display: 'table' } }>
            <div style={{ float: 'left', fontSize: '26px', fontWeight: 'bold', padding: '10px', paddingLeft: '20px', paddingTop: '12px' }}>
              {title}
            </div>
          </div>
          <Contents>
            {children}
          </Contents>
        </ModalWrap>
      </Overlay>
    </SelectModalContainer>
  );
}

const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  z-index: 16;
`;

const ModalWrap = styled.div`
  max-width: 825px;
  height: fit-content;
  border-radius: 10px;
  background-color: #fff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

const Contents = styled.div`
  margin: 0px;
  h1 {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 60px;
  }
  img {
    margin-top: 60px;
    width: 300px;
  }
`;
const Button = styled.button`
  font-size: 14px;
  padding: 10px 20px;
  border: none;
  background-color: #ababab;
  border-radius: 10px;
  color: white;
  font-style: italic;
  font-weight: 200;
  cursor: pointer;
  &:hover {
    background-color: #898989;
  }
`;
export default PCSelectModal;
